import { getSupabaseClient } from '../../../../core/supabase/client.js';

export type DeviceType = 'android' | 'ios' | 'web';

export class DeviceTokenRemoteDataSource {
  private get supabase() {
    return getSupabaseClient() as any;
  }

  /** Register/refresh this browser's FCM token. `fcm_token` is unique → upsert on conflict. */
  async upsertToken(input: { userId: string; fcmToken: string; deviceType: DeviceType }): Promise<void> {
    const { error } = await this.supabase
      .from('user_device_tokens')
      .upsert(
        {
          user_id: input.userId,
          fcm_token: input.fcmToken,
          device_type: input.deviceType,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'fcm_token' },
      );
    if (error) throw new Error(error.message);
  }

  async deleteToken(fcmToken: string): Promise<void> {
    const { error } = await this.supabase
      .from('user_device_tokens')
      .delete()
      .eq('fcm_token', fcmToken);
    if (error) throw new Error(error.message);
  }
}
